module.exports = __webpack_public_path__ + "static/media/browser-limits-cutoff.df81f0c9.png";


/*****************
 ** WEBPACK FOOTER
 ** ./public/browser-limits-cutoff.png
 ** module id = 429
 ** module chunks = 0
 **/